import { useEffect, useState } from 'react';
import { View } from '../../../contexts/MessagesContext';
import { onMessageRead } from './messageReadSubscribe';

export const useReadMessageEvent = (
    channel,
    client,
    view,
    channelId,
    sendInfoEvent,
    guestProfileId
) => {
    const [messageReadEventPending, setMessageReadEventPending] = useState(false);

    useEffect(() => {
        if (view === View.Channel && messageReadEventPending && guestProfileId) {
            setMessageReadEventPending(false);
            const payload = {
                action: 'CHANNEL_READ',
                channel_id: channelId,
                sender_id: guestProfileId,
            };

            sendInfoEvent(payload);
        }
    }, [view, channelId, guestProfileId, messageReadEventPending, sendInfoEvent]);

    useEffect(() => {
        const clickToAddNotification = event => {
            if (client.userID === event?.user?.id) {
                // the messageReadEventPending state is used for postponing the sending
                // of the message read event until we have the sender_id (partnerAttendeeId)
                setMessageReadEventPending(true);
            }
        };
        onMessageRead(channel, clickToAddNotification);

        return () => channel.off('message.read', clickToAddNotification);
    }, [channel, client.userID]);
};
